"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionOptions = exports.setPositionOptions = exports.getLocation = void 0;
var geoOptions = {
    timeout: 10 * 1000,
};
/**
 * Gets location from browser's geolocation API and calls callback.
 * Alternatively promise is also returned.
 *
 * Error.code can be:
 *  0: unknown error,
 *  1: permission denied,
 *  2: position unavailable (error response from location provider),
 *  3: timed out
 * @param callback
 */
function getLocation(callback) {
    var promise = new Promise(function (resolve, reject) {
        var geoSuccess = function (position) {
            if (callback) {
                callback({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            }
            resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            });
        };
        var geoError = function (error) {
            if (callback) {
                callback({
                    error: error,
                });
            }
            reject({
                error: error,
            });
        };
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
    });
    return promise;
}
exports.getLocation = getLocation;
/**
 * Set options to be used by position call
 * @param options
 */
function setPositionOptions(options) {
    Object.assign(geoOptions, options);
}
exports.setPositionOptions = setPositionOptions;
/**
 * View currently set position options
 */
function getPositionOptions() {
    return geoOptions;
}
exports.getPositionOptions = getPositionOptions;
exports.default = { getLocation: getLocation };
//# sourceMappingURL=LocationProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/business-features/LocationProvider/LocationProvider.js
// module id = 1474
// module chunks = 8